<template>
  <UiAvatar
    class="selection-option-icon"
    :class="{ 'is-text': Boolean(text) }"
    shape="square"
    :size="25"
    :src="src || undefined"
    fit="contain"
    :icon="!src && !text ? 'iconfont icon-tuxiang' : ''"
    :aria-label="$t(alt)"
  >
    <span v-if="!src && text">{{ $t(text) }}</span>
  </UiAvatar>
</template>

<script>
export default {
  name: 'SelectionOptionIcon',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    text: { type: String, default: '' }
  }
}
</script>

<style lang="scss">
.selection-option-icon {
  width: 25px !important;
  min-width: 25px;
  max-width: 25px;
  height: 25px !important;
  min-height: 25px;
  max-height: 25px;
  flex: 0 0 25px;
  box-sizing: border-box;
  vertical-align: middle;
}

.selection-option-icon > img {
  padding: 2px;
  box-sizing: border-box;
  object-fit: contain !important;
  object-position: center;
}

.selection-option-icon > .iconfont {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
}

.selection-option-icon.is-text {
  font-size: 12px;
}
</style>
